<template>
	<div id="toolbar-card-list-item" class="tw-flex tw-justify-between tw-items-center list-item tw-py-2 tw-pl-2 tw-pr-4 tw-rounded-lg" :class="[{ 'tw-bg-gray-100 tw-cursor-default' : active && !clickable_icon, 'hover:tw-bg-gray-100': !clickable_icon, 'clickable' : clickable, 'tw-py-4' : !show_avatar, 'disable-hover': clickable_icon, 'tw-pr-0': clickable_icon }]">
		<div>
			<img v-if='show_avatar' class="tw-w-7 tw-w-8 tw-mr-3 tw-rounded-full tw-bg-gray-400" :src="avatar_src"  alt="avatar of user"/>
			<span class="typography tw-text-black tw-pr-5 tw-self-center">{{ title }}</span>
		</div>
        <div v-if="show_icon" :class="[{ 'clickable-icon': clickable_icon }]" @click="$emit('iconClicked')">
		    <i class="far fa-fw tw-self-center" :style="icon_style" :class="[getValue(icon_class, active)]" />
        </div>
	</div>
</template>

<script>
export default {
	name: "ToolbarCardListItem",
	props: {
		active: {
			default: false,
			type: Boolean
		},
		show_avatar: {
			default: false,
		},
		avatar_src: {
			default: 'https://www.gravatar.com/avatar/865ccc56009fe05c9a393936ae87a19c?s=80&d=mm&r=g',
			type: String,
		},
		icon_class: {
			default: false,
			type: String | Array,
		},
		title: {
			required: true,
			type: String,
		},
        clickable: {
            default: true,
            type: Boolean,
        },
        show_icon: {
            default: true,
            type: Boolean,
        },
        clickable_icon: {
            default: false,
            type: Boolean,
        },
        icon_style: {
            default: '', // css transform property for custom icon alignment
            type: String
        }
	},
	methods: {
		getValue(val, active) {
			if (!Array.isArray(val)) return val;
			return active ? val[0] : val[1];
		},
	},
}
</script>

<style scoped lang="scss">
.disable-hover:hover {
    cursor: default !important;
}

.typography {
	font-weight: 400;
	font-size: 0.857rem;
}

.clickable {
	cursor: pointer;
}

.clickable-icon {
    @apply tw-flex tw-items-center tw-justify-center tw-rounded-full tw-h-10 tw-w-10 tw-cursor-pointer hover:tw-bg-blue-100 active:tw-bg-blue-200;
    :hover > & {
        @apply tw-text-blue-500;
    }
}
</style>
